import { lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${lightColorPalette.lbText};
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const StyledSummaryHeader = styled.div`
  color: ${lightColorPalette.lbTextSubdued};
  display: flex;
`;

export const StyledZeroLine = styled.div`
  width: 1rem;
  height: 0.3rem;
  background-color: ${lightColorPalette.lbTextSubdued};
`;

export const StyledDelta = styled.div`
  margin: 0 0.5rem;
  font-weight: 500;
  font-size: 1.2rem;
  & svg#ArrowUp {
    color: ${lightColorPalette.lbGreenDark}!important;
  }
  & svg#ArrowDown {
    color: #d6082b !important;
  }

  &.isPositive {
    color: ${lightColorPalette.lbGreenDark};
  }
  &.isNegative {
    color: #d6082b;
  }
  &.hidden {
    visibility: hidden;
  }
`;

export const StyledTotalStats = styled.div`
  margin-top: 2rem;
`;

export const StyledStatItem = styled.div`
  color: ${lightColorPalette.lbTextSubdued};
  margin: 0.5rem 0;
  & .value {
    font-weight: bold;
  }
`;

export const StyledTooltip = styled.div`
  font-size: 1.3rem;
`;
